import type {
    ExcludeStatusFields,
    ExcludeAccountFields,
    HubspotMappingField,
} from "app/pages/sales-intelligence/common-components/export-table/types";
import type { CRMListObjectsType, IntegrationSyncStatus } from "../../types";
import type { FetchError } from "app/pages/sales-intelligence/types";
import { createAction, createAsyncAction } from "typesafe-actions";
import type { IntegrationStatusResponse } from "../../components/types";
import type { DynamicsColumns } from "../type";

export const getDynamicsStatusAsync = createAsyncAction(
    "@@si/management/dynamics-integration/GET_STATUS_START",
    "@@si/management/dynamics-integration/GET_STATUS_SUCCESS",
    "@@si/management/dynamics-integration/GET_STATUS_FAILURE",
)<boolean, IntegrationStatusResponse, FetchError>();

export const getExcludeStatusFieldsAsync = createAsyncAction(
    "@@si/management/dynamics-integration/GET_EXCLUDE_STATUS_FIELDS_START",
    "@@si/management/dynamics-integration/GET_EXCLUDE_STATUS_FIELDS_SUCCESS",
    "@@si/management/dynamics-integration/GET_EXCLUDE_STATUS_FIELDS_FAILURE",
)<void, ExcludeStatusFields, FetchError>();

export const getDynamicsContactsFieldsAsync = createAsyncAction(
    "@@si/management/dynamics-integration/GET_CONTACTS_FIELDS_START",
    "@@si/management/dynamics-integration/GET_CONTACTS_FIELDS_SUCCESS",
    "@@si/management/dynamics-integration/GET_CONTACTS_FIELDS_FAILURE",
)<void, string[], FetchError>();

export const getExcludeAccountFieldsAsync = createAsyncAction(
    "@@si/management/dynamics-integration/GET_EXCLUDE_ACCOUNT_FIELDS_START",
    "@@si/management/dynamics-integration/GET_EXCLUDE_ACCOUNT_FIELDS_SUCCESS",
    "@@si/management/dynamics-integration/GET_EXCLUDE_ACCOUNT_FIELDS_FAILURE",
)<void, ExcludeAccountFields, FetchError>();

export const getMappingFieldsAsync = createAsyncAction(
    "@@si/management/dynamics-integration/GET_MAPPING_FIELDS_START",
    "@@si/management/dynamics-integration/GET_MAPPING_FIELDS_SUCCESS",
    "@@si/management/dynamics-integration/GET_MAPPING_FIELDS_FAILURE",
)<void, HubspotMappingField[], FetchError>();

export const putStatusFieldAsync = createAsyncAction(
    "@@si/management/dynamics-integration/PUT_STATUS_FIELD_START",
    "@@si/management/dynamics-integration/PUT_STATUS_FIELD_SUCCESS",
    "@@si/management/dynamics-integration/PUT_STATUS_FIELD_FAILURE",
)<void, void, FetchError>();

export const putIntegrationLeadFilterStatusAsync = createAsyncAction(
    "@@si/management/dynamics-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_START",
    "@@si/management/dynamics-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_SUCCESS",
    "@@si/management/dynamics-integration/PUT_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const getIntegrationLeadFilterStatusAsync = createAsyncAction(
    "@@si/management/dynamics-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_START",
    "@@si/management/dynamics-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_SUCCESS",
    "@@si/management/dynamics-integration/GET_INTEGRATION_LEAD_FILTER_STATUS_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const putFilterFieldsAsync = createAsyncAction(
    "@@si/management/dynamics-integration/PUT_FILTER_FIELDS_START",
    "@@si/management/dynamics-integration/PUT_FILTER_FIELDS_SUCCESS",
    "@@si/management/dynamics-integration/PUT_FILTER_FIELDS_FAILURE",
)<void, boolean, FetchError>();

export const disconnectDynamicsAsync = createAsyncAction(
    "@@si/management/dynamics-integration/DISCONNECT_START",
    "@@si/management/dynamics-integration/DISCONNECT_SUCCESS",
    "@@si/management/dynamics-integration/DISCONNECT_FAILURE",
)<void, void, FetchError>();

export const setSyncStatus = createAction(
    "@@si/management/dynamics-integration/SET_STATUS_MANUALLY",
)<IntegrationSyncStatus>();

export const setIsDynamicsAccountsExportEnabled = createAction(
    "@@si/management/dynamics-integration/SET_IS_ACCOUNTS_EXPORT_ENABLED",
)<boolean>();

export const setIsDynamicsContactsExportEnabled = createAction(
    "@@si/management/dynamics-integration/SET_IS_CONTACTS_EXPORT_ENABLED",
)<boolean>();

export const setIsDynamicsLeadsExportEnabled = createAction(
    "@@si/management/dynamics-integration/SET_IS_LEADS_EXPORT_ENABLED",
)<boolean>();

export const setIsDynamicsCompanyAsLeadsExportEnabled = createAction(
    "@@si/management/dynamics-integration/SET_IS_COMPANY_AS_LEADS_EXPORT_ENABLED",
)<boolean>();

export const getDynamicsColumnsAsync = createAsyncAction(
    "@@si/management/dynamics-integration/GET_COLUMNS_START",
    "@@si/management/dynamics-integration/GET_COLUMNS_SUCCESS",
    "@@si/management/dynamics-integration/GET_COLUMNS_FAILURE",
)<void, DynamicsColumns, FetchError>();

export const setIsDynamicsCrmLabelEnabled = createAction(
    "@@si/management/dynamics/manage-integration/SET_IS_CRM_LABEL_ENABLED",
)<boolean>();

export const setIsDynamicsCrmListEnabled = createAction(
    "@@si/management/dynamics/manage-integration/SET_IS_CRM_LIST_ENABLED",
)<boolean>();

export const setDynamicsCrmListObjectsType = createAction(
    "@@si/management/dynamics/manage-integrations/SET_DYNAMICS_CRM_LIST_OBJECTS_TYPE",
)<CRMListObjectsType>();
